"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "subiaco": {
    "8c40b4a2": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "skipSearch": false
    }],
    "barili-iegli": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50e04e37": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "skipSearch": false
    }],
    "caprola-campo-d-arco": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3a8989bf": [{
      "hkey": "199f1e48",
      "slug": "monte-livata-campo-dell-osso",
      "name": "Monte Livata-Campo dell'Osso",
      "primary": true,
      "skipSearch": false
    }],
    "centri-abitati-monte-livata-campo-dell-osso": [{
      "hkey": "199f1e48",
      "slug": "monte-livata-campo-dell-osso",
      "name": "Monte Livata-Campo dell'Osso",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6a2bc69a": [{
      "hkey": "9c2323c9",
      "slug": "la-torre-ponte-lucidi",
      "name": "La Torre-Ponte Lucidi",
      "primary": true,
      "skipSearch": false
    }],
    "la-torre-ponte-lucid": [{
      "hkey": "9c2323c9",
      "slug": "la-torre-ponte-lucidi",
      "name": "La Torre-Ponte Lucidi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5dc7e650": [{
      "hkey": "94e6156f",
      "slug": "cappuccini",
      "name": "Cappuccini",
      "primary": true,
      "skipSearch": false
    }],
    "le-camere-cappuccini": [{
      "hkey": "94e6156f",
      "slug": "cappuccini",
      "name": "Cappuccini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b089f534": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "skipSearch": false
    }],
    "montore-camarde": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ce48bad1": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "skipSearch": false
    }],
    "pozziglio-forma-focerale-san-vito": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "faf152dd": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "skipSearch": false
    }],
    "riarco-castagnola": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9e10e875": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "skipSearch": false
    }],
    "risano-colle-perino": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "57a2f0fc": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "skipSearch": false
    }],
    "sant-angelo-prato-maggiore-nocchitella": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "84db0e45": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "skipSearch": false
    }],
    "valle-papa-valle-chiappante": [{
      "hkey": "5ad75f65",
      "slug": "subiaco",
      "name": "Subiaco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;